import { render } from "./blogs-grid.vue?vue&type=template&id=3fc3de9b"
import script from "./blogs-grid.vue?vue&type=script&lang=js"
export * from "./blogs-grid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__